<script>
  import SettingsLayout from '../../components/SettingsLayout.svelte';
  import { settingsStore } from '../../stores/settingsStore.js';

  const { formData, managedByOwner } = settingsStore;
</script>

<SettingsLayout activeTab="cost-reporting" tabTitle="Cost Reporting">
  <div>
    <label for="excludedCostCodes" class="block text-sm font-medium text-gray-700 mb-2">
      Excluded Cost Codes
    </label>
    <input
      type="text"
      id="excludedCostCodes"
      bind:value={$formData.excludedCostCodes}
      readonly={$managedByOwner}
      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 read-only:bg-gray-100 read-only:cursor-not-allowed"
      placeholder="e.g., 9001, 9002"
    />
    <p class="mt-1 text-xs text-gray-500">
      Comma-separated list of cost code numbers to hide from cost reports (e.g. archived proposal lines).
    </p>
  </div>
</SettingsLayout>
